// extracted by mini-css-extract-plugin
module.exports = {"menuContainer":"styles_menuContainer__bOQGp","userHeader":"styles_userHeader__1vwIz","options":"styles_options__3wXMi"};